/**
 * Ajax Forms - stars
 * ======================================
 * - extend default ajaxForm.js
 */

import $ from "jquery";

$("body").on("submit", ".ajaxForm-stars", function(e) {
	var $form = $(this);

	var stars = $form.find('[name="stars"]:checked:last').val();
	var error = $form.find('[name="stars"]:first').data("error");

	if (typeof stars === "undefined") {
		alert(error);

		e.stopImmediatePropagation();
		e.preventDefault();
	}
});
